<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div matTooltip="The version of Terraform this Workspace will use">
  {{ workspace.terraformVersion }}
</div>
